import { connect } from "knockout-store";
import axios from "axios";
import searchJs from "./search";
import { toggleModal } from "../../utils/modal";
import ko from "knockout";
import { t } from "../../utils/translations";
import { r } from "../../utils/routing";

function templateListViewModel(params) {
  function check(value) {
    if (params.route() === r("database") && !params.searchDataLoading()) {
      params.searchDataLoading(true);
      Promise.all([
        axios.get(
          `${process.env.CONTENT_URL}/${process.env.LANGUAGE}_${process.env.SEARCH}.json`
        ),
      ])
        .then(([search]) => [search.data])
        .then(([search]) => {
          params.searchData(search);
          vm.dataLoading(false);
        });
    }
  }

  params.route.subscribe(function (newValue) {
    check(newValue);
  });
  params.searchData.subscribe(function (value) {
    setTimeout(() => {
      searchJs();
    }, 0);
  });

  const vm = {};
  vm.visible = () => params.route() === r("database");
  vm.data = () => params.searchData();
  vm.translation = (key) => t(key);
  vm.openSearchModal = (id) => {
    toggleModal("gallery", params.route(), (value) => {
      params.currentEvidenceID(id);
      params.galleryID(id);
      params.modal(value);
    });
  };
  vm.dataLoading = ko.observable(true);
  check(params.route());

  return vm;
}

function mapStateToParams({
  route,
  searchData,
  searchDataLoading,
  modal,
  currentEvidenceID,
  galleryID,
}) {
  return {
    route,
    searchData,
    searchDataLoading,
    modal,
    currentEvidenceID,
    galleryID,
  };
}

export default connect(mapStateToParams)(templateListViewModel);
